export interface PrecioViewModel {
  Id: number;
  Moneda: MonedaViewModel;
  Producto: ProductoViewModel;
  Usuario: UserViewModel;
  Fecha: Date | string;
  Actual: boolean;
  Precio: number;
  Varianza: number;
  Posicion: PosicionViewModel;
  Entrega: EntregaViewModel;
  Publicado: boolean;
  Validador: UserViewModel;
  Mercado: MercadoViewModel;
}

export interface CotizacionViewModel {
  Id: number;
  Valor: number;
  FechaCotizacion: number;
  Mon_ID: number;
  Moneda: MonedaViewModel;
  Actual: boolean;
  Validado: boolean;
  Usu_Validador_ID: number | null;
  UsuarioValidador: UserViewModel;
  Usu_Creador_ID: number;
  UsuarioCreador: UserViewModel;
  FechaPublicacion: number;
  Subent_Fin_ID: number;
  Varianza: number;
  SubentidadFinanciera: SubentidadFinancieraViewModel;
}

export interface SubentidadFinancieraViewModel {
  ID: number;
  EntidadFinanciera: EntidadFinancieraViewModel;
  Nombre: string;
  Descripcion: string;
  Codigo: string;
  Visibilidad: boolean;
  UsuarioCreador: UserViewModel;
  FechaCreacion: number;
}

export interface EntidadFinancieraViewModel {
  ID: number;
  Nombre: string;
  Descripcion: string;
  FechaCreacion: number;
  Creador: UserViewModel;
}

export interface PrecioGenericViewModel {
  Id: number;
  Moneda: MonedaViewModel;
  Producto?: ProductoViewModel;
  Usuario: UserViewModel;
  FechaCreacion: number;
  FechaPublicacion?: number;
  Actual?: boolean;
  Precio: number;
  Varianza: number;
  Posicion?: PosicionViewModel;
  Entrega?: EntregaViewModel;
  Validador: UserViewModel;
  Mercado?: MercadoViewModel;
  SubentidadFinanciera?: SubentidadFinancieraViewModel;
}

export interface PosicionViewModel {
  Posicion: string;
  Id: number;
  Fecha: Date | string;
  Ent_ID: number;
}

export interface EntregaViewModel {
  Id: number;
  Entrega: string;
  EsPosicion: boolean;
  Entrega_Id: number;
}

export interface MercadoViewModel {
  Id: number;
  Mercado: string;
  Visibilidad: boolean;
  Codigo: number;
}

export interface ProductoViewModel {
  Basis?: boolean;
  Id: number;
  Producto: string;
}

export interface MonedaViewModel {
  Id: number,
  Moneda: string,
  Simbolo: string
}

export interface AcopioViewModel {
  Id: number;
  AcopioNombre: string;
  CuentasIds: number[];
  CategoriaId: number;
  Parent: AcopioViewModel;
  ParentId: number;
}

export interface UserViewModel {
  UserId: number;
  UserName: string;
  UserFullName: string;
  AcopioId: number | null;
  AcopioZonaId: number | null;
  RolId: number;
  Rol: string;
  LastConnectionDateTime: number;
  Email: string;
  Domicilio: string;
  Telefono: string;
  UserAvatarUrl: string;
  Roles: RolViewModel[];
  Acopios: AcopioViewModel[];
  InMyNetwork: boolean;
  Permiso: UserPermisosViewModel;
}


export interface RolViewModel {
  RolName: string;
  Categorias: number[];
  Acopios: number[];
  Empresas: number[];
  Colaboradores: number[];
  Id: number;
  CurrentUserId: number;
  FullView: boolean;
  MesaNegocio: boolean;
  ProductosVisibles: number[];
  Autorizante: boolean;
  PublicadorPrecio: boolean;
  AutorizanteDolarizacion: boolean;
  Permiso: UserPermisosViewModel;
}

export interface UserPermisosViewModel {
  PermisoId: number;
  Nombre: string;
  Descripcion: string;
  Productos: ProductoViewModel[];
  Acciones: AccionViewModel[];
}

export interface AccionViewModel {
  AccionId: number;
  Nombre: string;
  Descripcion: string;
  AccionParentID: number | null;
}

export interface ClienteViewModel {
  Id: number;
  FullName: string;
  ClientContactId: number;
  Contacts: ClientContactViewModel[];
  ClientTypeId: number;
  Cuit: number | null;
  Departamento: string;
  Domicilio: string;
  DomicilioNumero: number | null;
  Email: string;
  UserId: number;
  Piso: string;
  CodigoPostalId: number | null;
  Latitud: string;
  Longitud: string;
  Habilitada: boolean;
  Acopios: AcopioViewModel[];
  Etiquetas: EtiquetaViewModel[];
  Telefono: string;
  FechaCreacion: number;
  InMyNetwork: boolean;
  An8: number | null;
  CuentaAcopio: ClienteAcopioViewModel[];
  CuentaAcopioByUserRol: AcopioViewModel[];
}

export interface ClientContactViewModel {
  ClientContactId: number;
  FullName: string;
  Email: string;
  ClienteId: number;
  Cuit: number;
  Telefono: string;
  Movil: string;
  Domicilio: string;
  CodigoPostal: number;
  UserId: number;
  Principal: boolean;
  Latitud: string;
  Longitud: string;
  Empresa: string;
  Puesto: string;
  InMyNetwork: boolean;
}

export interface EtiquetaViewModel {
  Id: string;
  Etiqueta: string;
  EtiquetaTipoId: number;
  FechaCreacionModificacion: number;
  ClientesId: number[];
  TotalCliente: number;
}

export interface ClienteAcopioViewModel {
  ClienteID: number;
  AcopíoID: number;
  Acopio: string;
  CuentaAcopio: number;
}

export class NegocioMetricasClass {
  TotalNegocios: number;
  TotalOrdenes: number;
  TotalIntenciones: number;
  TotalDisponible: number;
  TotalFuturo: number;
  constructor() {
    this.TotalNegocios = 0;
    this.TotalOrdenes = 0;
    this.TotalIntenciones = 0;
    this.TotalDisponible = 0;
    this.TotalFuturo = 0;
  }

  public setValues(values: NegocioMetricasViewModel) {
    this.TotalNegocios = Number(values.TotalNegocios.toFixed(2));
    this.TotalFuturo = Number(values.TotalFuturo.toFixed(2));
    this.TotalOrdenes = Number(values.TotalOrdenes.toFixed(2));
    this.TotalDisponible = Number(values.TotalDisponible.toFixed(2));
    this.TotalIntenciones = Number(values.TotalIntenciones.toFixed(2));
  }
}

export class NegocioMetricasViewModel {
  TotalNegocios: number;
  TotalOrdenes: number;
  TotalIntenciones: number;
  TotalDisponible: number;
  TotalFuturo: number;
}

export interface PriceSimulateViewModel {
  Metricas: NegocioMetricasViewModel;
  Negocios: NegocioViewModel[];
}

export interface NegocioViewModel {
  Fecha: number;
  TipoNegocio: TipoNegocioViewModel;
  Cliente: ClienteViewModel;
  Producto: ProductoViewModel;
  Toneladas: number;
  NegocioTipoPosicion: NegocioTipoPosicionVewModel;
  Entrega: EntregaViewModel;
  Cosecha: CosechaViewModel;
  Moneda: MonedaViewModel;
  Base: number;
  PrecioIdea?: number;
  PrecioEspecial: number;
  Match: boolean;
  Confirmacion: NegocioEstadoViewModel;
  Responsable: UserViewModel;
  Acopio: AcopioViewModel;
  Vencimiento: number;
  Autorizante: UserViewModel;
  Observaciones: string;
  Disponible: boolean;
  Colaboradores: UserViewModel[];
  Estado: NegocioEstadoViewModel;
  Id: number;
  PrecioOperacion: number;
  PrecioIdeaMatch?: number;
  CustomNotification: boolean;
  HorasNotificacion: number;
  Zona_ID: number;
  Zona: string;
  NegocioAvisos: NegocioAvisoDetailViewModel[];
  IndicadoresTn: number;
  CantidadNegocios: number;
  CantidadPaginas: number;
  Pesificar: number;
  Mercado: MercadoViewModel;
  FechaModificacion?: number;
  Fue_ID?: number;
}

export class TipoNegocioViewModel {
  public Id: number;
  public Tipo: string;
}

export class NegocioTipoPosicionVewModel {
  public NegocioTipoPosicion: string;
  public Id: number;
}

export class CosechaViewModel {
  public Id: number;
  public Cosecha: string;
  public AnoDesde: number;
  public AnoHasta: number;
}

export class NegocioEstadoViewModel {
  public Id: number;
  public Estado: string;
  public FechaEstado: number;
  public UsuarioEstado: UserViewModel;
  public Automatico: boolean;
  public Comentario: string;
}

export class NegocioAvisoDetailViewModel {
  public Cliente: ClienteViewModel;
  public Tipo: string;
  public Producto: ProductoViewModel;
  public Cosecha: CosechaViewModel;
  public Toneladas: number;
  public Entrega: EntregaViewModel;
  public Moneda: MonedaViewModel;
  public Precio: number;
  public Fecha: number;
  public NumeroAvisoAcopio: number;
  public ClienteCuentaAcopio: number;
  public Id: number;
  public EstadoAvisoActual: string;
  public AvisoCotizacion?: number;
}

export interface PrecioViewModel {
  Id: number;
  Moneda: MonedaViewModel;
  Producto: ProductoViewModel;
  Usuario: UserViewModel;
  Fecha: Date | string;
  Actual: boolean;
  Precio: number;
  Varianza: number;
  Posicion: PosicionViewModel;
  Entrega: EntregaViewModel;
  Publicado: boolean;
  Validador: UserViewModel;
  Mercado: MercadoViewModel;
}

export interface CotizacionViewModel {
  Id: number;
  Valor: number;
  FechaCotizacion: number;
  Mon_ID: number;
  Moneda: MonedaViewModel;
  Actual: boolean;
  Validado: boolean;
  Usu_Validador_ID: number | null;
  UsuarioValidador: UserViewModel;
  Usu_Creador_ID: number;
  UsuarioCreador: UserViewModel;
  FechaPublicacion: number;
  Subent_Fin_ID: number;
  Varianza: number;
  SubentidadFinanciera: SubentidadFinancieraViewModel;
}

export interface SubentidadFinancieraViewModel {
  ID: number;
  EntidadFinanciera: EntidadFinancieraViewModel;
  Nombre: string;
  Descripcion: string;
  Codigo: string;
  Visibilidad: boolean;
  UsuarioCreador: UserViewModel;
  FechaCreacion: number;
}

export interface EntidadFinancieraViewModel {
  ID: number;
  Nombre: string;
  Descripcion: string;
  FechaCreacion: number;
  Creador: UserViewModel;
}

export interface PrecioGenericViewModel {
  Id: number;
  Moneda: MonedaViewModel;
  Producto?: ProductoViewModel;
  Usuario: UserViewModel;
  FechaCreacion: number;
  FechaPublicacion?: number;
  Actual?: boolean;
  Precio: number;
  Varianza: number;
  Posicion?: PosicionViewModel;
  Entrega?: EntregaViewModel;
  Validador: UserViewModel;
  Mercado?: MercadoViewModel;
  SubentidadFinanciera?: SubentidadFinancieraViewModel;
}

export interface PosicionViewModel {
  Posicion: string;
  Id: number;
  Fecha: Date | string;
  Ent_ID: number;
}

export interface EntregaViewModel {
  Id: number;
  Entrega: string;
  EsPosicion: boolean;
  Entrega_Id: number;
}

export interface MercadoViewModel {
  Id: number;
  Mercado: string;
  Visibilidad: boolean;
  Codigo: number;
}

export interface ProductoViewModel {
  Basis?: boolean;
  Id: number;
  Producto: string;
}

export interface MonedaViewModel {
  Id: number,
  Moneda: string,
  Simbolo: string
}

export interface AcopioViewModel {
  Id: number;
  AcopioNombre: string;
  CuentasIds: number[];
  CategoriaId: number;
  Parent: AcopioViewModel;
  ParentId: number;
}

export interface UserViewModel {
  UserId: number;
  UserName: string;
  UserFullName: string;
  AcopioId: number | null;
  AcopioZonaId: number | null;
  RolId: number;
  Rol: string;
  LastConnectionDateTime: number;
  Email: string;
  Domicilio: string;
  Telefono: string;
  UserAvatarUrl: string;
  Roles: RolViewModel[];
  Acopios: AcopioViewModel[];
  InMyNetwork: boolean;
  Permiso: UserPermisosViewModel;
  UserNameJDE: string;
  canViewProduct:boolean;
}


export interface RolViewModel {
  RolName: string;
  Categorias: number[];
  Acopios: number[];
  Empresas: number[];
  Colaboradores: number[];
  Id: number;
  CurrentUserId: number;
  FullView: boolean;
  MesaNegocio: boolean;
  ProductosVisibles: number[];
  Autorizante: boolean;
  PublicadorPrecio: boolean;
  AutorizanteDolarizacion: boolean;
  Permiso: UserPermisosViewModel;
}

export interface UserPermisosViewModel {
  PermisoId: number;
  Nombre: string;
  Descripcion: string;
  Productos: ProductoViewModel[];
  Acciones: AccionViewModel[];
}

export interface AccionViewModel {
  AccionId: number;
  Nombre: string;
  Descripcion: string;
  AccionParentID: number | null;
}

export interface ClienteViewModel {
  Id: number;
  FullName: string;
  ClientContactId: number;
  Contacts: ClientContactViewModel[];
  ClientTypeId: number;
  Cuit: number | null;
  Departamento: string;
  Domicilio: string;
  DomicilioNumero: number | null;
  Email: string;
  UserId: number;
  Piso: string;
  CodigoPostalId: number | null;
  Latitud: string;
  Longitud: string;
  Habilitada: boolean;
  Acopios: AcopioViewModel[];
  Etiquetas: EtiquetaViewModel[];
  Telefono: string;
  FechaCreacion: number;
  InMyNetwork: boolean;
  An8: number | null;
  CuentaAcopio: ClienteAcopioViewModel[];
  CuentaAcopioByUserRol: AcopioViewModel[];
  cuentasAcopios: any;
}



export interface ClientContactViewModel {
  ClientContactId: number;
  FullName: string;
  Email: string;
  ClienteId: number;
  Cuit: number;
  Telefono: string;
  Movil: string;
  Domicilio: string;
  CodigoPostal: number;
  UserId: number;
  Principal: boolean;
  Latitud: string;
  Longitud: string;
  Empresa: string;
  Puesto: string;
  InMyNetwork: boolean;
}

export interface EtiquetaViewModel {
  Id: string;
  Etiqueta: string;
  EtiquetaTipoId: number;
  FechaCreacionModificacion: number;
  ClientesId: number[];
  TotalCliente: number;
}

export interface ClienteAcopioViewModel {
  ClienteID: number;
  AcopíoID: number;
  Acopio: string;
  CuentaAcopio: number;
}
export interface ClientListPaginatedResponse {
  count: number;
  rows: ClienteListAcopioViewModel[];
}

export interface ClienteListAcopioViewModel {
  id: number,
  catProveedor: string,
  catAgd: string,
  clientName: string,
  responsable: string,
  technologicalProfile: string,
  campaign: string,
  soja: string,
  maiz: string,
  supplies: string,
  expanded: boolean,
}

export interface CosechaViewModel {
  Id: number;
  Cosecha: string;
  AnoDesde: number;
  AnoHasta: number;
}

export interface NegocioTipoViewModel {
  Id: number;
  Tipo: string;
}

export interface ResponseGeneric<T> {
  exception: object;
  isValid: boolean;
  ResponseData: T;
  StatusCode: number;
}

export interface NegocioSaveViewModel {
  Id?: number;
  TipoNegocioId: number;
  ClienteId: number;
  ProductoId: number;
  Toneladas: number;
  NegocioTipoPosicionId: number | null;
  EntregaId: number;
  CosechaId: number;
  MonedaId: number;
  Base: number;
  PrecioIdea: number;
  PrecioEspecial: number;
  Match?: boolean;
  AcopioId: number;
  Vencimiento: number;
  Observaciones: string;
  Colaboradores: number[];
  UserId: number;
  PrecioOperacion: number | null;
  CustomNotification: boolean;
  HorasNotificacion: number | null;
  Pesificar: number;
  FechaCreacion?: Date | string;
  Fue_ID: number | null;
  MercadoId: number;
}

export interface ClienteSaldoViewModel {
  Acopio: AcopioViewModel;
  ClienteAcopio: ClienteAcopioViewModel;
  Producto: ProductoViewModel;
  Cosecha: CosechaViewModel;
  Disponible: number;
  ContratosPendientes: number;
  TNTotalesPendientes: number;
  TNCertificados: number;
  TNSinCertificar: number;
  Comprometidas: number;
  Oportunidades: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/ViewModels.ts